/* eslint-disable*/
import Vue from 'vue';
const OT_WIDTH = 60;
function getImageSize(src) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = function () {
      resolve(img);
    };
    img.src = src;
  });
}
export default {
  async getDetail(){
    const vm = new Vue();
    const tokenRes = await vm.$ajax.get(vm.$urlAPI.BaseData.getAndroidToken);
    const Token = tokenRes.Data.token;
    const resultData = JSON.parse(localStorage.resultData);
    const {ProductBatchID} = resultData;
    const detail = await vm.$ajax.jsonp(vm.$urlAPI.BaseData.GetEnterpriseAchievementPublic, {Token, ProductBatchID});
    return detail
  },
  //企业资质
  async createBusinessLicense(data, htmlFontSize, index){
    let Qualification = [];
    data.forEach(row => {
      JSON.parse(row.Qualification || '[]').forEach(imgSrc => {
        if (!Qualification.includes(imgSrc)) {
          Qualification.push(imgSrc);
        }
      });
    });
    const cardInfo = {
      title: '企业资质',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in Qualification) {
      const imgSrc = Qualification[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //质量认证
  async createCertificationStatus(data, htmlFontSize, index){
    let certs = [];
    data.forEach(row => {
      JSON.parse(row.CertificationStatus || '[]').forEach(item => {
        item.AuthenticationImg.forEach(({imgUrl}) => {
          if (!certs.includes(imgUrl)) {
            certs.push(imgUrl);
          }
        });
      });
    });
    const cardInfo = {
      title: '质量认证',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in certs) {
      const imgSrc = certs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //企业荣誉
  async createHonour(data, htmlFontSize, index){
    let imgs = [];
    data.forEach(row => {
      JSON.parse(row.Honour || '[]').forEach(item => {
        item.OrgLicence.forEach(({imgUrl}) => {
          if (!imgs.includes(imgUrl)) {
            imgs.push(imgUrl);
          }
        });
      });
    });
    const cardInfo = {
      title: '企业荣誉',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in imgs) {
      const imgSrc = imgs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //机：设备
  async createProFacility(data, htmlFontSize, index){
    const imgs = [];
    data.forEach(item => {
      const Production = JSON.parse(item.Production || '{}');
      const {proFacility = []} = Production;
      proFacility.forEach(({url, detail}) => {
        imgs.push(url);
      });
    });
    const cardInfo = {
      title: '机：设备',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in imgs) {
      const imgSrc = imgs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //料：种苗
  async createProMaterials(data, htmlFontSize, index){
    const imgs = [];
    data.forEach(item => {
      const Production = JSON.parse(item.Production || '{}');
      const {proMaterials = []} = Production;
      proMaterials.forEach(({url, detail}) => {
        imgs.push(url);
      });
    });
    const cardInfo = {
      title: '料：种苗',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in imgs) {
      const imgSrc = imgs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //法：生产方法
  async createProMethod(data, htmlFontSize, index){
    const imgs = [];
    data.forEach(item => {
      const Production = JSON.parse(item.Production || '{}');
      const {proMethod = []} = Production;
      proMethod.forEach(({url, detail}) => {
        imgs.push(url);
      });
    });
    const cardInfo = {
      title: '法：生产方法',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in imgs) {
      const imgSrc = imgs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  //环：大环境
  async createProEnvironment(data, htmlFontSize, index){
    const imgs = [];
    data.forEach(item => {
      const Production = JSON.parse(item.Production || '{}');
      const {proEnvironment = []} = Production;
      proEnvironment.forEach(({url, detail}) => {
        imgs.push(url);
      });
    });
    const cardInfo = {
      title: '环：大环境',
      subTitle: '',
      width: 80
    };
    const cols = [];
    for (let i in imgs) {
      const imgSrc = imgs[i];
      if (imgSrc) {
        const img = await getImageSize(imgSrc);
        let [width, height] = [img.width, img.height];
        if (height > 6.62 * htmlFontSize) {
          height = 6.62 * htmlFontSize;
          width = (img.width / img.height) * height;
        }
        cols.push([{
          hideTitle: true,
          content: imgSrc,
          width: width,
          height: height
        }]);
        cardInfo.width += (width + OT_WIDTH);
      }
    }
    if (cols.length > 0) {
      return {cols, cardInfo, index};
    }
  },
  async createCardTable(data, htmlFontSize){
    let layoutWidth = 0;
    const cardTable = [];
    let index = 1;
    let [
      businessLicenseCard,
      certificationStatusCard,
      honourCard,
      proFacilityCard,
      proMaterialsCard,
      proMethodCard,
      proEnvironmentCard
    ] = [null, null, null, null, null, null, null];
    //企业资质
    try {
      businessLicenseCard = await this.createBusinessLicense(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (businessLicenseCard) {
      cardTable.push(businessLicenseCard);
      layoutWidth += businessLicenseCard.cardInfo.width;
      index++;
    }
    //质量认证
    try {
      certificationStatusCard = await this.createCertificationStatus(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (certificationStatusCard) {
      cardTable.push(certificationStatusCard);
      layoutWidth += certificationStatusCard.cardInfo.width;
      index++;
    }
    //企业荣誉
    try {
      honourCard = await this.createHonour(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (honourCard) {
      cardTable.push(honourCard);
      layoutWidth += honourCard.cardInfo.width;
      index++;
    }
    //机：设备
    try {
      proFacilityCard = await this.createProFacility(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (proFacilityCard) {
      cardTable.push(proFacilityCard);
      layoutWidth += proFacilityCard.cardInfo.width;
      index++;
    }
    //料：种苗
    try {
      proMaterialsCard = await this.createProMaterials(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (proMaterialsCard) {
      cardTable.push(proMaterialsCard);
      layoutWidth += proMaterialsCard.cardInfo.width;
      index++;
    }
    //法：生产方法
    try {
      proMethodCard = await this.createProMethod(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (proMethodCard) {
      cardTable.push(proMethodCard);
      layoutWidth += proMethodCard.cardInfo.width;
      index++;
    }
    //环：大环境
    try {
      proEnvironmentCard = await this.createProEnvironment(data, htmlFontSize, index);
    } catch (err) {
      console.error(err);
    }
    if (proEnvironmentCard) {
      cardTable.push(proEnvironmentCard);
      layoutWidth += proEnvironmentCard.cardInfo.width;
      index++;
    }
    //
    layoutWidth = layoutWidth + (index * 100);
    layoutWidth = `${layoutWidth}px`;
    return {cardTable, layoutWidth};
  }
}



// WEBPACK FOOTER //
// ./src/views/detailInfo/org.js